import EastIcon from "@mui/icons-material/East"
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import { FC } from "react"

import { Button } from "src/components/common/button"
import { create } from "src/helpers/bem"
import { useTranslation } from "src/hooks/translation"

import { mergeDialog } from "src/states/dialogs"

import styles from "./AccountProfile.module.scss"

const bem = create(styles, "AccountProfile")

export const Contacts: FC = () => {
  const { messages: translations } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
  const profileTranslations = translations.pages.account.overview.profile

  const addContact = () => {
    mergeDialog("addEditContactDialog", { open: true })
  }

  const manageContacts = () => {
    mergeDialog("manageContactsDialog", {
      open: true,
      canDelete: true,
      selectType: undefined,
    })
  }

  return (
    <Stack className={bem("card")} direction={"column"}>
      <div className={bem("card", "header")}>
        <Typography variant="subtitle1">
          {profileTranslations.headers.contacts}
        </Typography>
      </div>
      <Stack
        className={bem("card", "content")}
        direction={"row"}
        justifyContent={"space-between"}
      >
        <Stack
          direction={"column"}
          maxWidth={isMobile ? "100%" : "60%"}
          spacing={1}
        >
          <Typography variant={"body1"}>
            {profileTranslations.contacts.info1}
          </Typography>
          <Typography variant={"body1"}>
            {profileTranslations.contacts.info2}
          </Typography>
          <Typography variant={"body1"}>
            {profileTranslations.contacts.info3}
          </Typography>
        </Stack>
        <Stack direction={"column"} spacing={2}>
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon fontSize="small" />}
            title={profileTranslations.buttons.addContact}
            onClick={() => addContact()}
          />
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon />}
            title={profileTranslations.buttons.manageContacts}
            onClick={() => manageContacts()}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
